import styled from 'styled-components';

export const BoldText = styled.div`
  font-weight: bold;
  color: #606060;
`;
